import { useApplicationScreenshotQuery, useCreateApplicationScreenshotMutation, useUpdateApplicationScreenshotMutation, useDeleteApplicationScreenshotMutation } from './useApplicationScreenshotsQuery';
import { ApplicationScreenshot } from '../types';

export const useApplicationScreenshot = (screenshotId?: string) => {
    const { data: record, isLoading: loading, refetch: fetchRecord } = useApplicationScreenshotQuery(screenshotId || '');
    const createApplicationScreenshotMutation = useCreateApplicationScreenshotMutation();
    const updateApplicationScreenshotMutation = useUpdateApplicationScreenshotMutation();
    const deleteApplicationScreenshotMutation = useDeleteApplicationScreenshotMutation();

    const createRecord = async (values: ApplicationScreenshot) => {
        return await createApplicationScreenshotMutation.mutateAsync(values);
    };

    const updateRecord = async (values: ApplicationScreenshot) => {
        if (typeof screenshotId === 'undefined') {
            throw new Error('screenshotId is required parameter');
        }
        return await updateApplicationScreenshotMutation.mutateAsync({ id: screenshotId, record: values });
    };

    const deleteRecord = async () => {
        if (typeof screenshotId === 'undefined') {
            throw new Error('screenshotId is required parameter');
        }
        return await deleteApplicationScreenshotMutation.mutateAsync(screenshotId);
    };

    return {
        record,
        loading,
        fetchRecord,
        createRecord,
        updateRecord,
        deleteRecord,
    };
};
